<template>
  <div>
    <div :class="{ overlay_setting: isLoadingData }">
      <i :class="{ loadding_setting: isLoadingData }"></i>
    </div>
    <AppHeader />
    <div class="setting_wrapper">
      <main class="setting_main">
        <div class="setting_menu">
          <ul class="setting_menu_list">
            <li
              class="setting_menu_item"
              @click="changeTab(COMMON_SETTING_TAB)"
            >
              <a id="1" class="setting_menu_link is_active">
                {{ labelProperties.FIRST_TAB }}
              </a>
            </li>
            <li
              class="setting_menu_item"
              @click="changeTab(ENTRY_SETTING_TAB)"
              v-if="hp_renkei_entry === 1"
            >
              <a id="2" class="setting_menu_link">
                {{ labelProperties.SECOND_TAB }}
              </a>
            </li>
            <template v-if="hp_renkei_job === 1">
              <li
                class="setting_menu_item"
                @click="changeTab(DISPLAY_SETTING_SUB_TAB_JOB)"
              >
                <a id="7" class="setting_menu_link">
                  {{ labelProperties.FIRST_SUB_TAB_JOB }}
                </a>
              </li>
              <li
                class="setting_menu_item"
                @click="changeTab(SEARCH_SETTING_SUB_TAB_JOB)"
              >
                <a id="8" class="setting_menu_link">
                  {{ labelProperties.SECOND_SUB_TAB_JOB }}
                </a>
              </li>
              <li
                class="setting_menu_item"
                @click="changeTab(REFERRAL_SETTING_SUB_TAB_JOB)"
              >
                <a id="9" class="setting_menu_link">
                  {{ labelProperties.THIRD_SUB_TAB_JOB }}
                </a>
              </li>
              <li
                v-if="is_plan_dispatch_basic === 1 && hp_renkei_job === 1"
                class="setting_menu_item"
                @click="changeTab(DISPATCH_JOB_SETTING_TAB)"
              >
                <a id="4" class="setting_menu_link">
                  {{ labelProperties.SIXTH_TAB }}
                </a>
              </li>
            </template>
            <li
              class="setting_menu_item"
              @click="changeTab(MASTER_SETTING_TAB)"
            >
              <a id="5" class="setting_menu_link">
                {{ labelProperties.FOURTH_TAB }}
              </a>
            </li>
            <li
              class="setting_menu_item"
              v-if="hp_renkei_job === 1"
              @click="changeTab(JOB_INFORMATION_TAB)"
            >
              <a id="6" class="setting_menu_link">
                {{ labelProperties.FIFTH_TAB }}
              </a>
            </li>
          </ul>
        </div>
        <div v-if="tab === COMMON_SETTING_TAB && !isLoadingData">
          <CommonSettings
            :groupName="groupName"
            :hp_renkei_entry="hp_renkei_entry"
            :hp_renkei_job="hp_renkei_job"
            :is_plan_dispatch_basic="is_plan_dispatch_basic"
            :unSavedData="unSavedData"
            :userId="userId"
            :token="token"
          />
        </div>
        <div v-if="tab === ENTRY_SETTING_TAB && !isLoadingData">
          <EntryScreenSettings
            :entryPageName="entryPageName"
            :entryOverview="entryOverview"
            :groupName="groupName"
            :unSavedData="unSavedData"
            :userId="userId"
            :token="token"
            :hp_renkei_job="hp_renkei_job"
            :hp_renkei_entry="hp_renkei_entry"
            :is_plan_dispatch_basic="is_plan_dispatch_basic"
          />
        </div>
        <div v-if="tab === MASTER_SETTING_TAB && !isLoadingData">
          <MasterSettings
            :groupName="groupName"
            :unSavedData="unSavedData"
            :userId="userId"
            :token="token"
          />
        </div>
        <div v-if="tab === JOB_INFORMATION_TAB && !isLoadingData">
          <JobInformation
            :groupName="groupName"
            :userId="userId"
            :token="token"
          />
        </div>
        <div v-if="tab === DISPLAY_SETTING_SUB_TAB_JOB && !isLoadingData">
          <ButtonAndThemeSettings
            :groupName="groupName"
            :jobPageName="jobPageName"
            :jobOverview="jobOverview"
            :unSavedData="unSavedData"
            :userId="userId"
            :token="token"
            :commonSetting="commonSetting"
          />
        </div>
        <div v-if="tab === SEARCH_SETTING_SUB_TAB_JOB && !isLoadingData">
          <JobSearchScreenSettings
            :groupName="groupName"
            :jobPageName="jobPageName"
            :jobOverview="jobOverview"
            :unSavedData="unSavedData"
            :userId="userId"
            :token="token"
            :commonSetting="commonSetting"
            :is_plan_dispatch_basic="is_plan_dispatch_basic"
          />
        </div>
        <div v-if="tab === REFERRAL_SETTING_SUB_TAB_JOB && !isLoadingData">
          <ReferralSettings
            :groupName="groupName"
            :unSavedData="unSavedData"
            :userId="userId"
            :token="token"
          />
        </div>
        <div v-if="tab === DISPATCH_JOB_SETTING_TAB && !isLoadingData">
          <DispatchJobSettings
            :groupName="groupName"
            :unSavedData="unSavedData"
            :userId="userId"
            :token="token"
          />
        </div>
      </main>
    </div>
    <AppFooter />
  </div>
</template>

<script>
import CommonSettings from "./CommonSettings";
import EntryScreenSettings from "./EntryScreenSettings";
import ButtonAndThemeSettings from "./JobScreen/ButtonAndThemeSettings.vue";
import ReferralSettings from "./JobScreen/ReferralSettings.vue";
import MasterSettings from "./MasterSettings";
import JobInformation from "./JobScreen/JobInformation.vue";
import DispatchJobSettings from "./JobScreen/DispatchJobSettings";
import GeneralPageLabelProperties from "../../properties/general_page/generalpage-labels.json";
import GeneralPageProperties from "../../properties/general_page/generalpage.json";
import Footer from "../Footer";
import Header from "../Header";
import authService from "../../services/AuthService";
import JobSearchScreenSettings from "../CommonSettings/JobScreen/JobSearchScreenSettings";
import env from "../../properties/env.json";
import { getGroupName } from "../../util/SystemUtil";
import { toHalfWidth } from "../../util/StringUtil";

const COMMON_SETTING_TAB = 1;
const ENTRY_SETTING_TAB = 2;
const JOB_SETTING_TAB = 3;
const DISPLAY_SETTING_SUB_TAB_JOB = 7;
const SEARCH_SETTING_SUB_TAB_JOB = 8;
const REFERRAL_SETTING_SUB_TAB_JOB = 9;
const DISPATCH_JOB_SETTING_TAB = 4;
const MASTER_SETTING_TAB = 5;
const JOB_INFORMATION_TAB = 6;

export default {
  name: "GeneralPage",
  components: {
    AppHeader: Header,
    AppFooter: Footer,
    CommonSettings: CommonSettings,
    EntryScreenSettings: EntryScreenSettings,
    JobSearchScreenSettings: JobSearchScreenSettings,
    MasterSettings: MasterSettings,
    JobInformation: JobInformation,
    DispatchJobSettings: DispatchJobSettings,
    ButtonAndThemeSettings: ButtonAndThemeSettings,
    ReferralSettings: ReferralSettings,
  },
  data: function() {
    return {
      entryScreenSettings: {},
      entryFormSetting: {},
      categories: [],
      entryPageName: "",
      entryOverview: "",
      jobOverview: "",
      jobPageName: "",
      tab: COMMON_SETTING_TAB,
      labelProperties: GeneralPageLabelProperties,
      properties: GeneralPageProperties,
      unSavedData: false,
      groupName: "",
      hp_renkei_entry: 1,
      hp_renkei_job: 1,
      is_plan_dispatch_basic: 1,
      userId: -1,
      token: "",
      COMMON_SETTING_TAB: COMMON_SETTING_TAB,
      ENTRY_SETTING_TAB: ENTRY_SETTING_TAB,
      JOB_SETTING_TAB: JOB_SETTING_TAB,
      DISPLAY_SETTING_SUB_TAB_JOB: DISPLAY_SETTING_SUB_TAB_JOB,
      SEARCH_SETTING_SUB_TAB_JOB: SEARCH_SETTING_SUB_TAB_JOB,
      REFERRAL_SETTING_SUB_TAB_JOB: REFERRAL_SETTING_SUB_TAB_JOB,
      DISPATCH_JOB_SETTING_TAB: DISPATCH_JOB_SETTING_TAB,
      MASTER_SETTING_TAB: MASTER_SETTING_TAB,
      JOB_INFORMATION_TAB: JOB_INFORMATION_TAB,
      commonSetting: {},
      isLoadingData: true,
      env: env,
    };
  },
  async created() {
    this.groupName = getGroupName();

    document
      .getElementsByTagName("body")[0]
      .style.setProperty("overflow", "hidden", "important");
    await this.getToken(sessionStorage.getItem("token"));
    this.getExtensions();

    this.userId = Number(sessionStorage.getItem("user_id"));

    this.$eventBus.$on("entryName", (data) => {
      this.entryPageName = data;
    });

    this.$eventBus.$off("entryName", (data) => {
      this.entryPageName = data;
    });

    this.$eventBus.$on("entryOverview", (data) => {
      this.entryOverview = data;
    });

    this.$eventBus.$off("entryOverview", (data) => {
      this.entryOverview = data;
    });

    this.$eventBus.$on("jobPageName", (data) => {
      this.jobPageName = data;
    });

    this.$eventBus.$off("jobPageName", (data) => {
      this.jobPageName = data;
    });

    this.$eventBus.$on("jobOverview", (data) => {
      this.jobOverview = data;
    });

    this.$eventBus.$off("jobOverview", (data) => {
      this.jobOverview = data;
    });

    this.$eventBus.$on("commonSetting", (data) => {
      this.commonSetting = data;
    });

    this.$eventBus.$off("commonSetting", (data) => {
      this.commonSetting = data;
    });
  },
  mounted() {
    window.history.pushState("", "", "/settings");
    this.$eventBus.$on("unSaved", (data) => {
      this.unSavedData = data;
    });
  },
  methods: {
    changeTab(nextTab) {
      if (this.unSavedData && nextTab !== this.tab) {
        if (
          window.confirm(this.properties.CONFIRM_LEAVE_TAB_MESSAGE) === true
        ) {
          this.unSavedData = false;
          this.nextTab(nextTab);
        } else {
          return false;
        }
      }
      this.nextTab(nextTab);
    },

    nextTab(nextTab) {
      let currentTab = document.getElementById(this.tab);
      if (currentTab !== nextTab) {
        currentTab.classList.remove("is_active");
        this.tab = nextTab;
        document.getElementById(nextTab).classList.add("is_active");
      }
    },

    getExtensions() {
      this.hp_renkei_entry = Number(sessionStorage.getItem("hp_renkei_entry"));
      this.hp_renkei_job = Number(sessionStorage.getItem("hp_renkei_job"));
      this.is_plan_dispatch_basic = Number(
        sessionStorage.getItem("is_plan_dispatch_basic")
      );
      sessionStorage.removeItem("hp_renkei_entry");
      sessionStorage.removeItem("hp_renkei_job");
      sessionStorage.removeItem("is_plan_dispatch_basic");
    },

    async getToken(ssoToken) {
      this.isLoadingData = true;
      await authService
        .getToken(ssoToken)
        .then((response) => {
          this.token = response.data.token;
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.isLoadingData = false;
        });

      if (sessionStorage.getItem("expires_in")) {
        setTimeout(
          () => this.getToken(sessionStorage.getItem("token")),
          Number(sessionStorage.getItem("expires_in")) * 900
        );
      }
    },
  },
};
</script>

<style scoped></style>
